<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/msg/param/mapping/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('qudao')">
            <yi_dictionary_select :type="'MESSAGE_CHANNEL'" :ids.sync="yt.conditions.channel">
            </yi_dictionary_select>
					</el-form-item>
          <el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc',msgConfId: yt.conditions.msgConfId})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
          {{$t('xinzeng')}}
        </el-button>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
                @click="yt.remove(scope.row,'/web/msg/param/mapping/delete')">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>

		</yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiaoxiqudao')" required>
            <yi_dictionary_select :type="'MESSAGE_CHANNEL'" :ids.sync="yt.editObj.channel">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('映射前参数')" required>
            <el-input type="textarea" :rows="2" v-model="yt.editObj.paramsAhead"></el-input>
          </el-form-item>
          <el-form-item :label="$t('映射后参数')" required>
            <el-input type="textarea" :rows="2" v-model="yt.editObj.paramsBehind"></el-input>
          </el-form-item>
          <el-form-item :label="$t('完整消息模板')" required>
            <el-input type="textarea" :rows="5" v-model="yt.editObj.templateMsg"></el-input>
          </el-form-item>
          <el-form-item :label="$t('消息模板id')" required>
            <el-input type="textarea" :rows="3" v-model="yt.editObj.templateId"></el-input>
          </el-form-item>

        </el-form>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/msg/param/mapping/create', beforeAdd)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiaoxiqudao')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.channel">
              <el-option :value=0 :label="$t('duanxin')"></el-option>
              <el-option :value=1 :label="$t('weixingongzhonghao')"></el-option>
              <el-option :value=2 :label="$t('yuyin')"></el-option>
              <el-option :value=3 :label="$t('zhanneixin')"></el-option>
              <el-option :value=4 :label="$t('youjian')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('映射前参数')" required>
            <el-input type="textarea" :rows="2" v-model="yt.editObj.paramsAhead"></el-input>
          </el-form-item>
          <el-form-item :label="$t('映射后参数')" required>
            <el-input type="textarea" :rows="2" v-model="yt.editObj.paramsBehind"></el-input>
          </el-form-item>
          <el-form-item :label="$t('完整消息模板')" required>
            <el-input type="textarea" :rows="5" v-model="yt.editObj.templateMsg"></el-input>
          </el-form-item>
          <el-form-item :label="$t('消息模板id')" required>
            <el-input type="textarea" :rows="3" v-model="yt.editObj.templateId"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/msg/param/mapping/update')" type="primary">
						{{$t('baocun')}}
					</el-button>

				</span>
      </template>

    </el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_global_message_mapping',
		components: {
		},
    props:{
      msgConfId: '',
    },
		data() {
			return {
				show: false,
				timer: null,
				list: [],

				columns: [{
					label: 'xiaoxiqudao',
					prop: 'channel',
          type: 'dictionary',
          key: 'MESSAGE_CHANNEL',
          width: 150
				}, {
					label: '映射前参数',
					prop: 'paramsAhead',
				}, {
					label: '映射后参数',
					prop: 'paramsBehind'
				}, {
          label: '完整消息模板',
          prop: 'templateMsg'
        }, {
          label: '消息模板id',
          prop: 'templateId'
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
          msgConfId: this.msgConfId
				}
				this.yt.get(1);
			}, 300)
		},
		destroyed() {
			clearTimeout(this.timer)
		},
		methods: {
      beforeAdd(params, url) {
        params.msgConfId = this.msgConfId
        return params
      },

		}
	};
</script>
